module.exports = __webpack_public_path__ + "img/userpic_undefined_artics.4e587a83.png";